import React, {useState, useEffect} from 'react'
import firebase from '../firebase/config'
import 'moment/locale/es-mx';
import ReCAPTCHA from "react-google-recaptcha"

function NewRegister(){

  const url2 = window.location.href;

  const [user, setUser] = useState({})
  
  const [paises, setPaises] = useState([])

  const [sp, setShowPassword] = useState(false)
  const [error, setError] = useState(false) 
  const [loginStatus, setLoginStatus] = useState(false)
  const [firstRegisterComplete, setFirstRegisterComplete] = useState(false)

  const [emessage, setEmessage] = useState("")
  const [btnMessage, setBtnMessage] = useState("¡Empezar!")
  const [nombreCompleto, setNombreCompleto] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [pais, setPais] = useState("")


  function checkInputs(){
    let val = 0
    let array = []
    let object = {
      nombreCompleto: nombreCompleto,
      email: email,
      password: password,
    }

    Object.keys(object).forEach(function(key) {
      if (object[key] === '' || object[key] === null) {
        val++
        array.push(key)
      }
    });
    if(val > 0){
      setError(true)
      setEmessage("Todos los campos son requeridos")
      setTimeout(() => {
        setError(false)
      }, 4000);
      setBtnMessage("¡Empezar!")
    }else{
      loginStatus ? login() : register()
    }
    return val > 0 ? true : false
  }

  function getPaises(){
    let tipos = []
    firebase.db.collection('Ciudades').get().then(data=>{  
      data.forEach(tipo=>{
        tipos.push(tipo.id)
        tipos.sort()
      })
      setPaises(tipos)
    })
    .catch(e=>{
      console.error("Error paises:",e)
    })
  }

  const ErrorComponent = ({msg}) => {
    return (
        <div className="error-alert">
            <span className="material-icons mr-2">error</span>
            {msg}
            <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
        </div>
    )
  }

  useEffect(() => {
    firebase.getCurrentUser().then((val)=>{
      setUser(val)
    });
    getPaises()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="signlog-wrapper">
      {error && <ErrorComponent msg={emessage === "" ? "Todos los campos son requeridos" : emessage}/>}
      <div className="signlog-left-container">
        
        <div className="signlog-form-img">
          <img src="../images/logo.png" alt="Priority Pet Aliados"/>
        </div>

        <div className="signlog-info-container">
          <p className="signlog-info-bold">Haz transacciones fácilmente</p>
          <p className="signlog-info-light">Podrás usarla desde donde te encuentres y sin intermediarios</p>
        </div>
        <div className="signlog-info-container">
          <p className="signlog-info-bold">Sube tus productos y servicios</p>
          <p className="signlog-info-light">Muestra lo que ofreces sin limitaciones y encuentra clientes potenciales</p>
        </div>
        <div className="signlog-info-container">
          <p className="signlog-info-bold">Administra tus reportes e inventario</p>
          <p className="signlog-info-light">El control y la organización son piezas claves para mantener tu negocio</p>
        </div>

      </div>
      <div className="signlog-right-container">
        { firstRegisterComplete ? 
        <div className="signlog-form">

          <p className="signlog-title">Completar perfil</p>
          
          <button onClick={()=>{}} className="btn btn-primary btn-block mb-2">Continuar</button>
          <p onClick={()=>{ setLoginStatus(!loginStatus); setFirstRegisterComplete(false)  }} className="signlog-a-link light cursor-pointer">{ loginStatus ? "No tengo una cuenta" : "Ya soy aliado"}</p>

        </div>
        : <div className="signlog-form">
          
          
          <p className="signlog-title"> {loginStatus ? "Iniciar sesión" : "Regístrate" }</p>
          
          { !loginStatus && 
            <div className="form-group col-lg-12 px-0 mb-4">
              <span className="input-label">País</span>
              <select className="form-control" value={pais} onChange={(e) => {setPais(e.target.value);}}>
                <option value="">Selecciona tu país</option>
                {paises.map(data => (
                    <option key={data} value={data}>{data}</option>
                ))}
              </select>
            </div>
          }
          
          { !loginStatus && 
            <div className="form-group col-lg-12 px-0 mb-4">
              <span className="input-label">Nombre completo</span>
              <input onChange={(e)=>{ setNombreCompleto(e.target.value) }} value={nombreCompleto} type="text" className="form-control" placeholder=""/>
            </div>
          }
          
          <div className="form-group col-lg-12 px-0 mb-4">
            <span className="input-label">Email</span>
            <input onChange={(e)=>{ setEmail(e.target.value) }} value={email} type="email" className="form-control" placeholder=""/>
          </div>
          <div className="form-group col-lg-12 px-0 mb-4">
            <span className="input-label">Contraseña</span>
            <div className="row align-items-center justify-content-spacebetween no-gutters">
              <div className="col-lg-10 px-0 ">
                <input onChange={(e)=>{ setPassword(e.target.value) }} value={password} type={sp ? "text" : "password"} className="form-control"/>
              </div>
              <span onClick={()=>{setShowPassword(!sp)}} className="material-icons mb-0 cursor-pointer color-primary">{sp ? "visibility_off" : "visibility" }</span>
            </div>
          </div>
          <div className="col-lg-12 mb-4">
            <ReCAPTCHA sitekey={
            url2.includes("prioritypet-aliados") || url2.includes("localhost") ? "6Leo8c8aAAAAAG8zagtbWvRX-rxjk7oLSverP4nV" 
            : "6LfjV0AbAAAAAI_JNbPvoQMbr1SLPc53kxfcjDqI"
            }/>
          </div>
          <button onClick={()=>{ checkInputs() }} className="btn btn-primary btn-block mb-2">{btnMessage}</button>
          <p onClick={()=>{ setLoginStatus(!loginStatus) }} className="signlog-a-link light cursor-pointer">{ loginStatus ? "No tengo una cuenta" : "Ya soy aliado"}</p>

        </div> }
      </div>
    </div>
  )

  async function register(){
    // alert("Registrado")
    window.location.href = "/";
  }
  
  async function login(){
    // alert("Sesion iniciada")
  }

}

export default NewRegister
